<template>
<div style="height: 450px;" class="ip-header">
  <v-layout justify-center>
    <v-flex>
      <v-img style="position: absolute; top: 0; height: 600px; width: 100%;" :src="header.src" alt="Logotype der Ideenpioniere"></v-img>
    </v-flex>
  </v-layout>
  <v-container>
  <v-layout>
    <v-flex style="z-index: 100">
      <h1 style="color: white; font-size: calc(35px + 0.7vw); line-height: 1.2;">{{header.title}}</h1>
      <!-- 125 Zeichen für Beschreibung -->
      <p style="max-width: 600px; color: white;">{{header.description}}</p>
    </v-flex>
  </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  props: ['header']
}
</script>

<style>
.ip-header .v-image__image--cover {
  background-position: bottom center !important;
}
</style>
